import { dateTime } from '@guestgoodie/helpers'

export function rangeToText(
  start: string,
  duration?: number | null,
  fullFormatter = dateTime.fullFormatter
) {
  const startTime = new Date(start)
  const startText = fullFormatter.format(startTime)

  const endText = (() => {
    if (!duration) return ''

    const endTime = new Date(startTime.getTime() + duration)

    if (dateTime.isSameDay(startTime, endTime))
      return dateTime.timeFormatter.format(endTime)
    return fullFormatter.format(endTime)
  })()

  return [`${startText}${endText ? ` - ${endText}` : ''}`]
}
